import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCompanyFooter]',
})
export class CompanyFooterDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
